<template>
  <div class="dlg">
    <header class="dlg__head">
      <div class="dlg__eyebrow">
        <span class="dlg__dot"></span>
        WAIZMANNVERGLEICH / KINDER-LEISTUNGEN
      </div>
      <h2 class="dlg__title">
        Vergleich der wichtigsten Kinder-Zahnarztleistungen
      </h2>
      <p class="dlg__sub">
        Welche kinderspezifischen Leistungen (KFO, FIS, PZR, Brackets, …) sind
        in den Tarifen enthalten?
      </p>
    </header>

    <div class="dlg__table-wrap">
      <table class="dlg__table dlg__table--compact">
        <thead>
          <tr>
            <th>Tarif</th>
            <th
              v-for="col in cols"
              :key="col.key"
              class="dlg__th-icon"
            >
              <TooltipHelper :toolkey="col.tooltip">
                <template v-slot:toolTipText>
                  <a>{{ col.label }}</a>
                  <br v-if="col.subLabel" />
                  <span v-if="col.subLabel" class="caption">
                    {{ col.subLabel }}
                  </span>
                </template>
              </TooltipHelper>
            </th>
            <th>Details</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="t in alletarife" :key="t.tarif_id">
            <td class="dlg__td-tarif">
              <router-link v-if="t.antraglink" :to="t.antraglink">
                {{ t.un_name }}
              </router-link>
              <span v-else>{{ t.un_name }}</span>
              <span v-if="t.empfehlung_type > 0" class="dlg__tipp">Tipp</span>
              <div class="dlg__td-tarif-sub">{{ t.tarif_title }}</div>
            </td>
            <td
              v-for="col in cols"
              :key="col.key"
              class="dlg__td-icon"
            >
              <span v-if="t[col.field] === 'Ja'" class="dlg__yes">Ja</span>
              <span v-else class="dlg__no">–</span>
            </td>
            <td>
              <router-link
                v-if="t.antraglink"
                :to="t.antraglink"
                class="dlg__btn"
              >
                Antrag &amp; Infopaket
              </router-link>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup>
  import { defineProps } from "vue";
  import TooltipHelper from "@/components/base/TooltipHelper.vue";

  defineProps({
    tarif: {
      type: Object,
      default: () => ({}),
    },
    berechnung: {
      type: Object,
      default: () => ({}),
    },
    alletarife: {
      type: Array,
      default: () => [],
    },
  });

  const cols = [
    { key: "kfo35", label: "KFO", subLabel: "KIG 3-5", tooltip: "kig1", field: "nice_tarif_leistung_kfo_mgkv" },
    { key: "kfo12", label: "KFO", subLabel: "KIG 1-2", tooltip: "kig1", field: "nice_tarif_leistung_kfo_ogkv" },
    { key: "fis", label: "FIS", tooltip: "fis", field: "nice_tarif_leistung_speziell_fis" },
    { key: "pzr", label: "PZR", tooltip: "kpzr", field: "nice_tarif_leistung_speziell_pzr_k" },
    { key: "kfofunk", label: "KFO-Funk", tooltip: "kfo_funk", field: "nice_tarif_leistung_speziell_k_kfofta" },
    { key: "minibrack", label: "Mini-Brack", tooltip: "mini_brack", field: "nice_tarif_leistung_speziell_k_minibrack" },
    { key: "kunstbrack", label: "Kunst.-Brack", tooltip: "kunst_brack", field: "nice_tarif_leistung_speziell_k_kunstbrack" },
    { key: "farblbogen", label: "farbl. Bögen", tooltip: "farbl_bogen", field: "nice_tarif_leistung_speziell_k_farblbogen" },
    { key: "lingua", label: "Lingua", tooltip: "lingua", field: "nice_tarif_leistung_speziell_k_lingua" },
    { key: "retainer", label: "Retainer", tooltip: "retainer", field: "nice_tarif_leistung_speziell_k_retainer" },
    { key: "invisa", label: "Invisa.", tooltip: "invisa", field: "nice_tarif_leistung_speziell_k_invisa" },
  ];
</script>

<style scoped>
  .dlg__th-icon,
  .dlg__td-icon {
    text-align: center !important;
    padding-left: 6px !important;
    padding-right: 6px !important;
  }
  .dlg__table--compact :deep(td),
  .dlg__table--compact :deep(th) {
    padding-top: 6px;
    padding-bottom: 6px;
  }
</style>
